const classDesplegadoCompartir = '--desplegado';
const classDesplegado = '--desplegado';
const classBusqueda = '--expandir';

const btnCompartir = document.getElementById('btnCompartir');
const liSecciones = document.getElementById('navSecciones');
const classActivo = 'activo';
let elementoposicionado = 0;
let disableScroll = 0;
export function Initialize() {

}


export function buscador() {
    $('button[data-id="btnBuscadorHeader"]').on('click', function () {
        buscar($('input[data-id="buscadorHeader"]').val());
    });

    $('input[data-id="buscadorHeader"]').on('keypress', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            buscar($('input[data-id="buscadorHeader"]').val());
        }
    });
}

export function buscadorDesplegable() {
    $('button[data-id="btnBuscadorDesplegable"]').on('click', function () {
        buscar($('input[data-id="buscadorDesplegable"]').val());
    });

    $('input[data-id="buscadorDesplegable"]').on('keypress', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            buscar($('input[data-id="buscadorDesplegable"]').val());
        }
    });
}

function buscar(value) {
    window.location.href = window.config.Statics.BuscadorUrl + value;
}

export function bannerHeaderLogo() {
    setTimeout(() => {
        $('.banner-header-logo div').fadeIn();
    }, 3000);


    if ($(window).width() <= 769) {
        // Link usuario mobile
        let link = $('body header#cabezal .usuario');
        link.click(function () {
            window.open('http://micuenta.lanacion.com.ar/', '_blank');
        });
    }

}



function abrirCerrarDesplegable() {
    const navHeader = document.getElementById('header')
    const classListHeader = navHeader.classList;
    if (classListHeader.contains(classDesplegado)) {
        cerrarDesplegable()
    } else {
        abrirDesplegable()
    }
}

function abrirDesplegable() {
    const body = document.querySelector('body')
    const navHeader = document.getElementById('header')

    navHeader.classList.add(classDesplegado)
    body.classList.add(classDesplegado)
    liSecciones.classList.add(classActivo)
}

function cerrarDesplegable() {
    const body = document.querySelector('body')
    const navHeader = document.getElementById('header')

    navHeader.classList.remove(classDesplegado)
    body.classList.remove(classDesplegado)
    liSecciones.classList.remove(classActivo)
}

const lisDesplegable = document.querySelectorAll('#desplegableHeader > ul li:not(#navSecciones)')
lisDesplegable.forEach(el => {
    el.addEventListener('mouseover', e => {
        liSecciones.classList.remove('activo');
    })
})

const asignarClickDesplegablesMenu = () => {
    const links = document.querySelectorAll('[data-selector-menu-click]')
    links.forEach(el => {
        el.addEventListener('click', event => {
            var classListUL = event.currentTarget.parentElement.classList
            if (!classListUL.contains(classDesplegado)) {
                classListUL.add(classDesplegado);
            } else {
                classListUL.remove(classDesplegado);
            }
            links.forEach(el => {
                if (el.parentElement.classList.contains(classDesplegado) && el.innerHTML !== event.currentTarget.innerHTML) {
                    el.parentElement.classList.remove(classDesplegado);
                }
            })
        })
    })
}

asignarClickDesplegablesMenu();

function onOffDropdown(desplegar) {
    let element, name, arr;
    element = document.body;
    name = "dropdown";
    arr = element.className.split(" ");

    if (arr.indexOf(name) === -1 && desplegar) {
        element.className += " " + name;
    } else {
        element.classList.remove(name);
    }
}

$(document).ready(function () {
    /* DROPDOWN */
    $('.onoff-dropdown').click(function () {
        onOffDropdown(true);
    });

    $("#btnCompartir").on("click", function (event) {
        event.stopPropagation();
        checkClasskBtnCompartir(true);
    });

    $(document).keydown(function (event) {
        if (event.keyCode === 27) {
            onOffDropdown(false);
        }
    });


    $('.nav__dropdown > ul > li:has(ul)').addClass("has--children");

    $('.nav__dropdown > ul > li > button').click(function () {
        var checkElement = $(this).next();
        $('.nav__dropdown li').removeClass('item--active');
        $(this).closest('li.has--children').addClass('item--active');

        if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
            $(this).closest('li').removeClass('item--active');
            checkElement.slideUp('normal');
        }

        if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
            $('.nav__dropdown ul ul:visible').slideUp('normal');
            checkElement.slideDown('normal');
        }

        if (checkElement.is('ul')) {
            return false;
        } else {
            return true;
        }

    });
    /* END DROPDOWN */

    /* MEGATOP */
    const bannerMegaTop = document.querySelector('.bn-megatop');
    //Invalido este codigo porque estan referenciados en ScriptMegatop

    if (bannerMegaTop) {

        var altoPantalla = $(window).height();

        window.onresize = function () {
            var altoPantalla = $(window).height();
            $(".bn-megatop").animate({ height: altoPantalla }, 100);
        }

    }


    /* END MEGATOP */
});





// WEBPACK FOOTER //
// ./Statics/scripts/Header.js